import termsFI from '@axo/form/feature/terms-and-conditions/generated/terms-and-conditions-fi.json';
import termsNO from '@axo/form/feature/terms-and-conditions/generated/terms-and-conditions-no.json';
import termsSE from '@axo/form/feature/terms-and-conditions/generated/terms-and-conditions-se.json';
import { termsSchema } from '@axo/form/feature/terms-and-conditions/src/types/Terms';
import { MarketCountryCode } from '@axo/shared/types';
import { useAxoFormContext } from '../../../context/AxoForm/AxoForm';

const termsJson: Record<MarketCountryCode, any> = {
  [MarketCountryCode.Norway]: termsNO,
  [MarketCountryCode.Finland]: termsFI,
  [MarketCountryCode.Sweden]: termsSE,
  [MarketCountryCode.Denmark]: new Error('Not implemented'),
};


export const useTerms = (external: boolean) => {
  const { marketCountry } = useAxoFormContext();

  const json = termsSchema.parse(termsJson[marketCountry]);

  return { loading: false, data: json };
};
